import { FETCH_CHECKOUT_DATA_REQUEST, FETCH_CHECKOUT_DATA_SUCESS, FETCH_CHECKOUT_DATA_ERROR } from "./checkoutConstType";

const initialCheckoutState = {
    loading: true,
    data: {
    },
    error: ''
}
export const checkoutReducer = (state = initialCheckoutState, action) => {
    
    switch (action.type) {
        case FETCH_CHECKOUT_DATA_REQUEST:
            return {
                ...state,
                loading: true
            }
        case FETCH_CHECKOUT_DATA_SUCESS:
            return {
                ...state,
                data: action.payload,
                loading:false,
                error: ''
            }
        case FETCH_CHECKOUT_DATA_ERROR:
            return {
                ...state,
                filterdata: {},
                error: action.payload
            }
        default:
           return state;
    }
}